import "babel-polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import "default-passive-events";
import vant from "./VantUi/vant";
import "./common/style/index.less";
import "vant/lib/index.css";
import "amfe-flexible";
import echarts from "echarts";
import axios from "axios";
import VueAxios from "vue-axios";

import utils from "./common/js/utils";

Vue.prototype.axios = axios;

Vue.config.productionTip = false;
Vue.use(vant);
Vue.use(VueAxios, axios);

Vue.prototype.$echarts = echarts;

// 全局过滤器：其中，formatStr形如："Y-M-D h:m:s"
Vue.filter("formatDateToBeijing", function (date, formatStr) {
  if (date) {
    let formatedDate = new Date(date.replace(/-/g, '/')).getTime() + 1000 * 60 * 60 * 8;
    const format = formatStr || "Y-M-D h:m:s";
    return utils.formatTime(formatedDate, format);
  } else {
    return "";
  }
});

/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js